import React from 'react'
import classNames from "classnames"

function AppWrap({className,...props}) {
  const compClass = classNames({
    "nk-wrap": true,
    [`${className}`]: className,
  });
  return (
    <div className={compClass} style={{marginTop: "-1.5rem"}}>
        {props.children}
    </div>
  )
}

export default AppWrap